import type { CSSProperties } from "react";
import { deviceDetector, ospThemes } from "@ospweb/sdk-ui";

import type { EdgenModalCreateAbleProps } from "@components/EdgenModal";

export const PORTFOLIO_ACCOUNTS_MODAL_PC_WIDTH_PX = 740;

/** 固定 flex 列高度，避免 height:auto 时子级 h-full 失效、吸底 CTA 被裁切 */
const desktopContentSize = {
  maxHeight: "min(852px, 90vh)",
  height: "min(852px, 90vh)",
} as const;

export const portfolioAccountsModalShellProps = (): Pick<
  EdgenModalCreateAbleProps,
  | "centered"
  | "className"
  | "containerClassName"
  | "contentStyle"
  | "containerStyle"
  | "styles"
  | "titleStyle"
  | "showClose"
  | "closable"
  | "destroyOnClose"
> => {
  const isMobile = deviceDetector.isMobile();

  const sharedContentStyle: CSSProperties = {
    backgroundColor: ospThemes.colors.background_solid_neutral_primary,
    padding: 0,
    overflow: "hidden",
    width: "100%",
    maxWidth: isMobile ? "100vw" : `${PORTFOLIO_ACCOUNTS_MODAL_PC_WIDTH_PX}px`,
    display: "flex",
    flexDirection: "column",
    // H5 全屏底部抽屉（EDG-436 后续）：内容组件与 MyAccountsPage 同源（flex column
    // + 内部滚动 + 吸底 CTA），天然支持整屏；无顶圆角
    ...(isMobile
      ? { height: "100dvh", borderRadius: "0px" }
      : desktopContentSize),
  };

  return {
    centered: !isMobile,
    showClose: false,
    closable: false,
    destroyOnClose: true,
    className: isMobile ? undefined : "!max-w-[740px]",
    containerClassName: isMobile
      ? "!w-screen !max-w-[100vw]"
      : "!rounded-[24px] !overflow-hidden !w-full !max-w-[740px]",
    contentStyle: sharedContentStyle,
    containerStyle: {
      padding: 0,
      // 滚动交给 PortfolioAccountsModalContent 内部 flex-1 区；外层禁滚避免双滚动条
      overflow: "hidden",
      width: "100%",
      maxHeight: "100%",
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      // H5 全屏：容器需确定高度（DrawerH5 滚动容器读 height 作 maxHeight；无确定
      // 高度时内容根 h-full 挂空 → flex-1 滚动区失去约束、按钮无法钉底）
      ...(isMobile ? { height: "100dvh" } : { height: "100%" }),
    },
    styles: {
      content: sharedContentStyle,
      body: {
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        padding: 0,
        overflow: "hidden",
      },
      wrapper: {
        zIndex: 10000,
      },
      mask: {
        zIndex: 10000,
      },
    },
    titleStyle: {
      minHeight: 0,
    },
  };
};
